import React from "react";
import PropTypes from "prop-types";
import { RadioButton } from "../../../components/RadioButton";
import { Input } from "../../../components/Input";

/**
 * Size configs for the embed.
 * @param {EmbedSize.propTypes} props
 */
export const EmbedSize = (props) => {
	return (
		<div className="mb-8">
			<div className="font-bold mb-3">Board Size</div>
			<div className="grid grid-cols-2">
				<RadioButton
					isChecked={!props.value.boardSize}
					onCheck={() =>
						props.onChange({
							...props.value,
							boardSize: null,
						})
					}
					label="Responsive"
					subTitle="(recommended)"
					color="plugin-3"
				/>
				<div className="flex flex-col">
					<RadioButton
						isChecked={!!props.value.boardSize}
						onCheck={() =>
							props.onChange({
								...props.value,
								boardSize: [1000, 630],
							})
						}
						label="Fixed Size"
						color="plugin-3"
					/>
					{props.value.boardSize && (
						<div className="mt-3 flex items-center">
							<Input
								type="number"
								value={props.value.boardSize[0]}
								onChange={(value) => {
									props.onChange({
										...props.value,
										boardSize: [
											value,
											props.value.boardSize[1],
										],
									});
								}}
								color="plugin-3"
								placeholder="W"
								className="w-16"
							/>
							<span className="-mt-1 mx-1">x</span>
							<Input
								type="number"
								value={props.value.boardSize[1]}
								onChange={(value) => {
									props.onChange({
										...props.value,
										boardSize: [
											props.value.boardSize[0],
											value,
										],
									});
								}}
								color="plugin-3"
								placeholder="H"
								className="w-16"
							/>
							<span className="-mt-1 mx-2">Pixels</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

EmbedSize.propTypes = {
	value: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
};
